import { createReducer } from 'src/helpers/reducer';
import actionTypes from './actionTypes';
import type { IRateEngineShort, IRateEngineListShortState } from './types';

const initState: IRateEngineListShortState = {
  data: null,
  isLoading: false,
  failed: false,
  generation: 0,
};

function onFetchRequest(state: IRateEngineListShortState): IRateEngineListShortState {
  return { ...state, isLoading: true, failed: false };
}

function onFetchSuccess(
  state: IRateEngineListShortState,
  { payload }: { payload: { data: IRateEngineShort[] } },
): IRateEngineListShortState {
  return { ...state, data: payload.data, isLoading: false, failed: false, generation: state.generation + 1 };
}

// A failure counts as an answer: `data` falls back to a list and `generation` bumps, so readers waiting
// on one are released instead of skeletoning forever. `failed` separates "request died" from "no engines".
function onFetchError(state: IRateEngineListShortState): IRateEngineListShortState {
  return { ...state, data: state.data ?? [], isLoading: false, failed: true, generation: state.generation + 1 };
}

export default createReducer(initState, {
  [actionTypes.FETCH_REQUEST]: onFetchRequest,
  [actionTypes.FETCH_SUCCESS]: onFetchSuccess,
  [actionTypes.FETCH_ERROR]: onFetchError,
});
